<div class="modal-header">
    <h4 class="modal-title">
        <i data-feather="alert-circle"></i> Sertifika İmzalama
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
    <form [formGroup]="form">
        <div class="mb-3">
            <label for="password" class="form-label">Sertifika Şifresi</label>
            <input type="password" id="password" class="form-control" formControlName="password"
                placeholder="Lütfen şifrenizi giriniz"
                [ngClass]="{'is-invalid': form.get('password')?.touched && form.get('password')?.invalid}">
            <div class="invalid-feedback">
                Şifre girilmesi zorunludur.
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Vazgeç</button>
    <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="form.invalid">
        Onayla ve İmzala
    </button>
</div>